/**
 * The Scores games panes' heading row, ISSUE-1380: the "Scores" h1 with the
 * search entry at its right edge, a 44px round link into `/scores/search`
 * (v1 put the same search in the Scores app bar). The link carries the
 * accessible name; the glyph is decorative.
 */
import { cn } from "@sportsmet/ui";
import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { ICON_BUTTON_CLASS } from "../../icons/actionIcons";
import { SearchIcon } from "../../icons/glyphs";
import { SCORE_SEARCH_ENTRY_LABEL } from "./scoreSearchLogic";

export const SCORES_HEADING = "Scores";

export const ScoresHeading = (): ReactNode => (
  <div className="flex items-center justify-between gap-2">
    <h1 className="text-h1 text-ink">{SCORES_HEADING}</h1>
    <Link
      to="/scores/search"
      aria-label={SCORE_SEARCH_ENTRY_LABEL}
      data-testid="scores-search-entry"
      className={cn(
        ICON_BUTTON_CLASS,
        "text-ink no-underline hover:bg-surface-sunken",
      )}
    >
      <SearchIcon size="md" />
    </Link>
  </div>
);
